export enum SurveyType {
  PreChat = 'prechat',
  PostChat = 'postchat',
  Ticket = 'ticket',
  Custom = 'custom',
}
